import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { type ObjectDto } from '@bizzdesign/shared/models';
import { type UUID } from '@bizzdesign/bizzdesign-sdk/uuid';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'bd-content-overview-objects-list',
  imports: [FormsModule, CheckboxModule],
  templateUrl: './content-overview-objects-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentOverviewObjectsListComponent {
  objectsList = input<ObjectDto[]>(undefined);
  selectedIds = input<UUID[]>(undefined);
  showCheckboxes = input<boolean>(false);

  selectedObjects = computed(() => {
    const selectedIds = this.selectedIds();
    const objectsList = this.objectsList();
    return selectedIds && objectsList
      ? objectsList.filter((o) => selectedIds.includes(o.id as UUID))
      : objectsList;
  });
}
